import type { ReactNode } from 'react';
import { QueryStatus } from '@/shared/ui/QueryStatus';
import { SECTION_STATUS } from './api';

const STATUS_SUFFIX: Record<number, string> = {
  [SECTION_STATUS.REJECT]: ': отклонено',
  [SECTION_STATUS.VERIFY]: ': верифицировано',
};

type Props = {
  title: string;
  status: number;
  isLoading: boolean;
  error: unknown;
  children: ReactNode;
};

/** Page frame shared by all verification section pages. */
export const SectionLayout = ({ title, status, isLoading, error, children }: Props) => (
  <>
    <section className="content-header">
      <h1>
        {title}
        {STATUS_SUFFIX[status]}
      </h1>
    </section>
    <section className="content">
      <div className="box">
        <div className="box-body">
          <QueryStatus isLoading={isLoading} error={error} errorText="Ошибка загрузки данных" />
          {children}
        </div>
      </div>
    </section>
  </>
);